import axiosInstance from "../../utils/axiosInstance";

// notification
import { notify } from "../../components/alerts";

// loading
import { setUser, setLoading } from "../../store/slices/auth";
import axios, { isAxiosError } from "axios";
import { AppDispatch } from "../../store/store";
import { NavigateFunction } from "react-router-dom";
import { IChangePassword, IUpdateUser } from "../../store/@types/user";
import {
  ILogin,
  ILoginResponse,
  ILogout,
  IRegister,
  IRegisterResponse,
} from "../../store/@types/auth";

const authEndpint = "/api/v1/client/auth";

export const auth_user = async (
  formData: ILogin,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());

  try {
    const response = await axiosInstance.post<ILoginResponse>(
      `${authEndpint}/login`,
      formData,
    );

    const { user, tokens } = response.data.data;
    const { access_token, refresh_token } = tokens;

    localStorage.setItem("@serial", access_token);
    localStorage.setItem("@refresh_token", refresh_token);

    dispatch(setUser(user));

    navigate("/dashboard");
  } catch (err) {
    if (isAxiosError(err)) {
      console.log(err.response?.data?.message);
    }
  } finally {
    dispatch(setLoading());
  }
};

export const register_user = async (
  formData: IRegister,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post<IRegisterResponse>(
      `${authEndpint}/register`,
      formData,
    );

    const { user, tokens } = response.data.data;
    const { access_token, refresh_token } = tokens;

    localStorage.setItem("@serial", access_token);
    localStorage.setItem("@refresh_token", refresh_token);
    dispatch(setUser(user));
    navigate("/dashboard");
  } catch (err) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      notify({ type: "error", message });
    }
  } finally {
    dispatch(setLoading());
  }
};

/**
 *
 * auth -> state
 * @param {Function} dispatch
 */

export const changePassword = async (dispatch: AppDispatch, formData: any) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      `${authEndpint}/change-password`,
      formData,
    );

    notify({ type: "success", message: response.data });
  } catch (error) {
    if (isAxiosError(error)) {
      const { message } = error?.response?.data;
      notify({ type: "error", message: message });
    }
  }
  dispatch(setLoading());
};

/**
 *
 * @param {*} dispatch
 * @param {*} formData
 * @returns
 */

export const forgot_password = async (dispatch: AppDispatch, formData: any) => {
  let result;
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      `${authEndpint}/forgot-password`,
      formData,
    );

    result = response?.data;
  } catch (error: any) {
    result = false;
  }
  dispatch(setLoading());
  return result;
};

export const change_password = async (
  dispatch: AppDispatch,
  formData: any,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      `${authEndpint}/change-password`,
      formData,
    );

    notify({ type: "success", message: response.data?.message });
    navigate("/login");
  } catch (error) {
    if (isAxiosError(error)) {
      const { message } = error?.response?.data;
      notify({ type: "error", message });
      console.log(error?.response?.data);
    }
  }
  dispatch(setLoading());
};

/**
 *
 * @param {*} data
 * @param {*} dispatch
 * @param {*} navigate
 *
 * Google @Auth
 */

export const get_google_link = (token: string) => {
  return `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`;
};

export const get_google_profile = async (
  token: string,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  try {
    const response = await axios.get(get_google_link(token), {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const { identifier: email, name, id } = response.data;

    if (window.location.pathname === "/login") {
      auth_user(
        { identifier: email, password: id, client: "web" },
        dispatch,
        navigate,
      );
    } else {
      register_with_google_auth(
        {
          name,
          email,
          phone: "",
          address: "",
          accept_policy: "1",
          url: get_google_link(token),
          password: id,
          password_confirmation: id,
        },
        dispatch,
        navigate,
      );
    }
  } catch (error) {
    if (isAxiosError(error)) {
      const { message } = error?.response?.data;
      notify({ type: "error", message: "Something Happened." });
      console.log(message);
    }
  }
};

export const register_with_google_auth = async (
  data: any,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    await axiosInstance.post("/auth/register-with-google-auth", data);

    notify({ type: "success", message: "Profile Created." });
    navigate("/login");
  } catch (err) {
    notify({ type: "error", message: "Cannot Register with this email." });
  }
  dispatch(setLoading());
};

export const logout = async (navigate: NavigateFunction, data: ILogout) => {
  try {
    const response = await axiosInstance.post(`${authEndpint}/logout`, data);
    if (!response.data.success) {
      notify({
        type: "error",
        message: response.data.message || "Something went wrong",
      });
    } else {
      localStorage.removeItem("@serial");
      localStorage.removeItem("@refresh_token");
      navigate("/login");
    }
  } catch (error) {
    notify({ type: "error", message: "Something went wrong" });
  }
};

// ==================================================================================================
export const update = async (dispatch: AppDispatch, form: IUpdateUser) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.patch("v1/update-user", form);

    const { message, data } = response.data;
    dispatch(setUser(data));
    notify({ type: "success", message });
    dispatch(setLoading());
    return true;
  } catch (error: any) {
    if (isAxiosError(error)) {
    }
    notify({ type: "error", message: "Profile cannot be updated" });
    dispatch(setLoading());
    return false;
  }
};

export const update_password = async (
  dispatch: AppDispatch,
  form: IChangePassword,
  navigate: NavigateFunction,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/v1/change-password", form);

    const { message } = response.data;

    notify({ type: "success", message });
    dispatch(setLoading());
    navigate("/login");
  } catch (error) {
    if (isAxiosError(error)) {
      const { message } = error?.response?.data;
      notify({ type: "error", message });
    }
    dispatch(setLoading());
    return false;
  }
  dispatch(setLoading());
};
